<template lang="pug">
v-container#login-layout
  v-row.text-center(justify="center", style="position: absolute")
    v-col(cols="12")
      .circle
  //- v-row
  //-     v-col
  .language-select.text-right(style="position: relative")
    span.font-weight-bold(v-if="language == 'tw'") 中文(繁體)
    span(v-else)
      a.text-decoration-underline(@click="changeLanguage('tw')") 中文(繁體)
    span.mx-2 |
    span.font-weight-bold(v-if="language == 'en'") English
    span(v-else)
      a.text-decoration-underline(@click="changeLanguage('en')") English
  Loading
  v-row.text-center
    v-col(cols="12")
      v-row(justify="center")
        .display-1.font-weight-bold.sumup.mb-10 
          v-img(contain, src="@/assets/images/logo.png", max-height="50")
      //-         v-img(src="https://media.sproutsocial.com/uploads/2017/02/10x-featured-social-media-image-size.png" height="108" width="240" @click="$router.push('/')")
      v-row(justify="center")
        .page-title.mb-10(style="z-index: 99") {{ $t(nowPage.title) }}
      v-row(justify="center", :class="nowPage.description == '' ? 'd-none' : ''")
        .page-description.mb-10(style="z-index: 99") {{ $t(nowPage.description, discriptionParams) }}
      v-row(justify="center")
        router-view
</template>

<script>
import Loading from "@/components/globals/Loading"

export default {
  components: {
    Loading
  },
  data: () => ({
    language: "tw",
    page: {
      Login: {
        title: "Auth.__Login",
        description: ""
      },
      ForgotPassword: {
        title: "Auth.__ForgotPassword",
        description: ""
      },
      ResetPassword: {
        title: "Auth.__ResetYourPassword",
        description: ""
      },
      Signup: {
        title: "Auth.__RegisterForFree",
        description: "Auth.__ServiceIntroduction"
      },
      BusinessInfo: {
        title: "Auth.__VerifiedTitle",
        description: "Auth.__VerifiedDescription"
      },
      Verify: {
        title: "Auth__Verifying",
        description: ""
      },
      VerifyEmail: {
        title: "Auth.__VerifyEmail",
        description: ""
      },
      Collaborator: {
        title: "Collaborators.__BecomeMember",
        description: "Collaborators.__InviteCollaboratorHint"
      }
    },
    discriptionParams: {}
  }),
  methods: {
    changeLanguage(key) {
      this.$store.dispatch("account/updateLanguage", key)
      this.$i18n.locale = key
      this.language = key
      location.href = "/" + key + location.pathname.substring(location.pathname.lastIndexOf("/"))
    }
  },
  computed: {
    nowPage() {
      return this.page[this.$route.name]
    }
  },
  created() {
    this.language = this.$store.getters["account/language"]()
    if (this.$route.name == "Collaborator") {
      this.discriptionParams = { bizName: this.$route.query.bn }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/login.scss";
.sumup {
  color: #e67339;
  z-index: 99;
}

.circle {
  left: 50%;
  width: 120vh;
  height: 120vh;
  border-radius: 60vh;
  background-color: #fdf1eb;
  position: fixed;
  margin-left: -60vh;
  margin-top: -10vh;
}
</style>
